import { UseMutationOptions, useMutation } from "react-query";

import { TreeNode } from "components/AccountPlanTree";
import { queryClient } from "infra/packages/react-query";
import { useInvalidateQuery } from "infra/packages/react-query";
import { showErrorAxios } from "infra/helpers/alerta";
import { incrementItem } from "../utils";

const addNode = (root: TreeNode[], item: TreeNode) => {
  return root?.map?.(
    ({ key, id, nome, breadcrumb, ordem, items = [], ...rest }: TreeNode) => {
      const node: TreeNode = { ...rest, key, id, nome, ordem, breadcrumb };
      if ((key && key === item.key) || (id && id === item.id)) {
        const parentBreadcrumb = node.breadcrumb;

        const last = items[items.length - 1];

        const _breadcrumb = !last
          ? parentBreadcrumb + ".1"
          : incrementItem(last.breadcrumb);

        items = [
          ...items,
          {
            key: _breadcrumb,
            nome: "",
            breadcrumb: _breadcrumb,
            ordem: (ordem ?? 0) + 1,
            operacao: node.operacao,
            ativo: true,
          },
        ];
      }
      if (items) node.items = addNode(items, item);
      return node;
    }
  );
};

export default function useInsertFinancialCategory() {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const mutationOptions: UseMutationOptions = {
    onMutate: async (variables: any) => {
      // Cancela outras requisições
      await queryClient.cancelQueries("/v1/categoria-financeira");
      // Guarda o valor anterior
      const previous = queryClient.getQueryData<any>(
        "/v1/categoria-financeira"
      );
      // adiciona o nó e retorna o novo valor
      const newValue = addNode(previous, variables);
      // Adicionado o novo valor
      if (previous) {
        queryClient.setQueryData("/v1/categoria-financeira", [...newValue]);
      }
      return { previous };
    },
    onSuccess: () => {
      doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
    },
    onError: (err: any, __: any, context: any) => {
      showErrorAxios(err);

      if (context?.previous) {
        queryClient.setQueryData("/v1/categoria-financeira", context.previous);
      }
    },
  };

  return useMutation(async (body: any) => {
    return body;
  }, mutationOptions);
}
